export const mediaLinks = {
  phone: '8 (4242) 312-532',
  email: 'SAKHIPOTEKA@MAIL.RU',
  workRegime: 'ПН - ПТ: 09:00 - 18:00  СБ - ВС: ВЫХОДНОЙ',
  support: 'mailto:sakhipoteka@mail.ru',
};
